

//? - =========================  STICKY HEADER  ========================= -//
//? - =========================  STICKY HEADER  ========================= -//
class ProductPage {
    constructor(el) {
        this.body = document.querySelector('body')
        if (window.innerWidth > 1024) {
            this.$header = {
                el: document.querySelector('.header-prod '),
                hold: el.querySelector('.header-prod__hold'),
                infos: el.querySelector('.header-prod__infos'),
                release: document.querySelector('.header-prod__release'),
                $last_img: document.querySelector('.product-single__media:last-child'),
                $scroll_down: document.querySelectorAll('.header-prod__infos__scroll-down')
            }
            this.$sticky_shop = document.querySelectorAll('.sticky-shop')
            this.sticky_length = this.$sticky_shop.length
            if (this.sticky_length > 0) {
                this.$footer = document.querySelector('footer')
            }

            if (document.querySelectorAll('.open-modal').length > 0) {
                this.modalHeader()
            }

            this.isVariant = document.querySelectorAll('.isvariant') || null
            if(this.isVariant.length == 0) {
                this.scrollToMedia()
            }
            this.isScrollDown = false
            if( this.$header.$scroll_down.length > 0 && this.$header.hold.getBoundingClientRect().height > window.innerHeight ) { 
                this.isScrollDown = true 
            }
        }
        else {
            let that = this
            this.$models = document.querySelectorAll('.media-model')
            this.$models.forEach(el => {
                el.addEventListener('click', ()=> {
                    console.log(el.querySelector('.btn-view-ar').dataset.idmodel)
                    console.log(el.querySelector('.btn-view-ar').dataset.modeltitle)
                    window.ShopifyXR.launchXR({
                        model3dId: el.querySelector('.btn-view-ar').dataset.idmodel,
                        title: `${el.querySelector('.btn-view-ar').dataset.modeltitle}`,
                    })
                })
            })
            if(this.$models.length > 0) this.arEnabled()
            
        }

        this.galleryZoom()
        this.tick()
    }











    //? - =========================  ENABLE AR  ========================= -//
    //? - =========================  ENABLE AR  ========================= -//
    arEnabled() {

        const $ViewModelBtns = document.querySelectorAll('.icon-3D')
        const $CloseModelBtns = document.querySelectorAll('.media-model .icon-zoom')
        $ViewModelBtns.forEach(el => {
            el.addEventListener('click', ()=> {
                let $card = el.closest('li')
                $card.classList.add('enable-model')
            })
        })
        
        $CloseModelBtns.forEach(el => {
            el.addEventListener('click', ()=> {
                let $card = el.closest('li')
                $card.classList.remove('enable-model')
            })
        })


        function setupShopifyXr() {
            if (!window.ShopifyXR) {
                console.log('if')
                document.addEventListener('shopify_xr_initialized', function () {
                    setupShopifyXr();
                });
            } else {
                
                console.log('else')
                window.ShopifyXR.addModels();
                window.ShopifyXR.setupXRElements();
            }
        }

        window.Shopify.loadFeatures([
            {
                name: 'shopify-xr',
                version: '1.0',
                onLoad: setupShopifyXr
            }
        ]);

        // console.log(window.Shopify)
        // console.log(window.ShopifyXR)
    }

    
    
    
    
    
    
    
    
    
    
    //? - =========================  SCROLL TO MEDIA  ========================= -//
    //? - =========================  SCROLL TO MEDIA  ========================= -//
    


    scrollToMedia() {
        const var_media = document.querySelectorAll(`[data-media-id="${this.$header.el.dataset.featmediaId}"]`)
        if(var_media.length < 1 ) return
        if(window.innerWidth > 1024) {
            window.scrollTo({
                top: var_media[0].offsetTop
            });
        } else {
            document.querySelector('.header-prod__gallery__travel').scrollLeft  = 0
            document.querySelector('.header-prod__gallery__travel').scrollLeft = var_media[0].getBoundingClientRect().left
        }
    }








    //? - =========================  MODAL HEADER  ========================= -//
    //? - =========================  MODAL HEADER  ========================= -//
    modalHeader() {
        this.$modal = {
            el: document.querySelector('.header-prod__infos__modal'),
            close: document.querySelector('.header-prod__infos__modal__close'),
            hold: document.querySelectorAll('ul.header-prod__infos__modal__hold'),
            each_li: document.querySelector('.header-prod__infos__modal__each'),
            trg: document.querySelectorAll('.open-modal'),
            title: document.querySelector('.heading-modal'),
        }


        let that = this
        function openModal(e) {
            e.preventDefault();
            that.body.classList.add('is-modal-prod')
            let $el = e.target
            let $accordion = $el.closest('.header-prod__accordion')
            let $content = $accordion.querySelector('.accordion__content')

            that.$modal.title.textContent = $accordion.querySelector('.accordion__title').textContent
            that.$modal.each_li.querySelector('.accordion__content').innerHTML = $content.innerHTML
            if ($content.getBoundingClientRect().height > window.innerHeight * 0.3) {
                that.$modal.el.classList.add('modal-extended')
            }
        }

        this.$modal.trg.forEach((el, index) => {
            el.addEventListener('click', (e) => {
                openModal(e)
            })

            this.$modal.close.addEventListener('click', () => {
                document.querySelectorAll('.modal-active').forEach(el => el.classList.remove('modal-active'))
                that.$modal.el.classList.remove('modal-extended')
                that.body.classList.remove('is-modal-prod')
            })
        })
    }










    //? - =========================  GALLERY ZOOM  ========================= -//
    //? - =========================  GALLERY ZOOM  ========================= -//
    galleryZoom() {
        this.$prev = document.querySelector(".gallery-zoom__prev");
        this.$next = document.querySelector(".gallery-zoom__next");
        this.$zoom_travel = document.querySelector(".gallery-zoom__hold")
        this.$each_image = document.querySelectorAll(".gallery-zoom__each");
        this.$trg_zoom = document.querySelectorAll("li.product-single__media.media-img");
        this.$counter_dyna = document.querySelector(".gallery-zoom__counter .dyna");
        this.$close = document.querySelector(".gallery-zoom__close");
        this.imgs_length = this.$each_image.length;

        this.current = 0;
        let that = this
        function scrollPrev() {
            if (that.current > 0) {
                that.$zoom_travel.scrollTo({
                    top: that.$each_image[that.current - 1].offsetTop + 2,
                    behavior: "smooth"
                });
            }
        }
        this.$prev.addEventListener("click", scrollPrev);

        function scrollNext() {
            if (that.current < that.imgs_length - 1) {
                that.current++;
                let goto = that.current;
                that.$zoom_travel.scrollTo({
                    top: that.$each_image[goto].offsetTop + 2,
                    behavior: "smooth"
                });
            }
        }
        this.$next.addEventListener("click", scrollNext);



        this.$trg_zoom.forEach(el => {
            el.addEventListener('click', () => {
                that.body.classList.add('is-gallery')
                let thisIndex = [].indexOf.call(that.$trg_zoom, el);
                that.$zoom_travel.scrollTo({
                    top: that.$each_image[thisIndex].offsetTop + 2,
                    behavior: "smooth"
                });
            })
        })

        this.$close.addEventListener('click', () => {
            that.body.classList.remove('is-gallery')
        })
        document.onkeydown = function (evt) {
            if (this.body.classList.contains('is-gallery')) {
                evt = evt || window.event;
                var isEscape = false;
                if ("key" in evt) {
                    isEscape = (evt.key === "Escape" || evt.key === "Esc");
                } else {
                    isEscape = (evt.keyCode === 27);
                }
                if (isEscape) {
                    that.body.classList.remove('is-gallery')
                }
            }
        };
    }


    tick() {

        if (window.innerWidth > 1024) {
            /* _______ header infos */
            let currentScroll = window.scrollY
            let release_top = this.$header.$last_img.getBoundingClientRect().top
            let vh = window.innerHeight

            if (release_top > 0) {
                this.$header.infos.style.transform = `translateY(${currentScroll}px)`
            }


            /* _______ sticky shop */
            if (this.sticky_length > 0) {
                let footer_top = this.$footer.getBoundingClientRect().top
                if (release_top < (vh * 0.85) && footer_top > (vh * 0.85)) {
                    this.$sticky_shop[0].classList.add('active-sticky')
                }
                else {
                    this.$sticky_shop[0].classList.contains('active-sticky') ? this.$sticky_shop[0].classList.remove('active-sticky') : null
                }
            }

            


            /* _______ scrolldown */
            if (this.isScrollDown) {
                
                if (release_top < (vh * 0.2) ) {
                    this.$header.$scroll_down[0].classList.add('hide-scrolldown')
                }
                else {
                    this.$header.$scroll_down[0].classList.remove('hide-scrolldown')
                }
            }
        }




        /* _______ galleryZoom */
        let that = this
        if (this.body.classList.contains('is-gallery')) {
            this.$each_image.forEach((el, index) => {
                let thisIndex = [].indexOf.call(that.$each_image, el);
                let el_top = el.getBoundingClientRect().top;
                let el_bottom = el.getBoundingClientRect().bottom;
                if (el_top < 0 && el_bottom > 0) {
                    this.current = thisIndex;
                    if (this.current < 10) {
                        that.$counter_dyna.innerHTML = `0${thisIndex + 1}`;
                    }
                    else {
                        that.$counter_dyna.innerHTML = `${thisIndex + 1}`;
                    }
                }
            });
        }

        window.requestAnimationFrame(() => {
            this.tick()
        })
    }

}




const $header_product = document.querySelectorAll('.header-prod')
if ($header_product.length > 0) {
    new ProductPage($header_product[0])
}










//? - =========================  PRODUCT CARD  ========================= -//
//? - =========================  PRODUCT CARD  ========================= -//
class AddToCardProd {
    constructor() {

        this.setters()
        const $update_form = document.querySelector('.update-form')
        $update_form.addEventListener('click', this.setters.bind(this))
    }


    setters() {
        this.card = {
            add_to_cart_inp: document.querySelector('.add-to-cart-input'),
            price_total: document.querySelector('.total-price'),
            input_qty: document.querySelector('.input-qty'),
            btn_minus: document.querySelector('.btn-minus'),
            btn_plus: document.querySelector('.btn-plus'),
            display_qty: document.querySelector('.display-qty'),
            form: document.querySelector('form.add-to-cart') || null,
            locale: `${document.querySelector('.header-prod').dataset.locale}`,
            iso_currency: `${document.querySelector('.header-prod').dataset.currency}`
        }
        if( this.card.form ) {
            this.currency_symbol = this.card.form.dataset.currency
            this.price = `${Number(this.card.form.dataset.price.replace(/[^0-9.-]+/g, ""))}`
            this.qty = 1


            
            this.$reset_plans =  document.querySelectorAll('.reset-sellplans')
            if(this.$reset_plans.length < 1) {
                // ______ click minus
                this.card.btn_minus.addEventListener('click', () => {
                    if (this.qty > 1) {
                        this.qty--
                        this.card.display_qty.innerHTML = `${this.qty}`
                        this.card.input_qty.setAttribute('value', this.qty)
                        this.parsePrice(this.price * this.qty, this.card.price_total)
                    }
                })


                // ______ click plus
                this.card.btn_plus.addEventListener('click', () => {
                    if (this.qty < this.card.input_qty.dataset.maxQty) {
                        this.qty++
                        this.card.display_qty.innerHTML = `${this.qty}`
                        this.card.input_qty.setAttribute('value', this.qty)
                        this.parsePrice(this.price * this.qty, this.card.price_total)
                    }
                })
            }
    }


    }

    parsePrice(data, $el) {
        let price_right = new Intl.NumberFormat(this.card.locale, {
            style: "currency",
            currency: this.card.iso_currency
        }).format(data / 100);
        $el.innerHTML = `${price_right}`
    }

}


const $add_to_cart_form = document.querySelectorAll('#AddToCartForm')
if ($add_to_cart_form.length > 0) {
    new AddToCardProd()
}


const $sticky_to_cart = document.querySelectorAll('.sticky-shop')
if ($sticky_to_cart.length > 0) {
    new AddToCardProd($sticky_to_cart[0])
}